module.exports = __webpack_public_path__ + "static/media/as.43207abf.svg";